import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Components/Login/Login";
import Dashboard from "./Components/Dashboard/Dashboard";
import AnimationLab from "./Components/AnimationLab/AnimationLab";
import NotFound from "./Components/NotFound/NotFound";

import AdminLayout from "./Components/Admin/AdminLayout";
import Deals from "./Components/Admin/Deals/Deals";
import Sellers from "./Components/Admin/Sellers/Sellers";
import Services from "./Components/Admin/Services/Services";
import Targets from "./Components/Admin/Targets/Targets";
import Passwords from "./Components/Admin/Passwords";

// Het animatielab draait op dezelfde maand/jaar-route als het dashboard.
const labPath = () => {
  const now = new Date();
  return `/animaties/${now.getMonth() + 1}/${now.getFullYear()}`;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/dashboard/:month/:year" element={<Dashboard />}></Route>

        {/* Testscherm: het dashboard met verzonnen cijfers, om de animaties
            los te kunnen bekijken. Zonder maand gaat hij naar vandaag. */}
        <Route path="/animaties" element={<Navigate to={labPath()} replace />}></Route>
        <Route path="/animaties/:month/:year" element={<AnimationLab />}></Route>

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/deals" replace />} />
          <Route path="deals" element={<Deals />} />
          <Route path="verkopers" element={<Sellers />} />
          <Route path="diensten" element={<Services />} />
          <Route path="targets" element={<Targets />} />
          <Route path="wachtwoorden" element={<Passwords />} />

          <Route path="deals/*" element={<Navigate to="/admin/deals" replace />} />
          <Route path="users/*" element={<Navigate to="/admin/verkopers" replace />} />
          <Route path="products/*" element={<Navigate to="/admin/diensten" replace />} />
          <Route path="bonuses/*" element={<Navigate to="/admin/targets" replace />} />
          <Route path="changePasswords" element={<Navigate to="/admin/wachtwoorden" replace />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
        <Route path="/*" element={<NotFound />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
